import React, { useState } from "react";
import "../styles/Layout.css";
import Sidebar from "./Sidebar";
import { Header } from "./Header";
import { Outlet } from "react-router-dom";

const AdminPanel = ({ user, token }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div className="app-container">
      <Sidebar
        user={user}
        token={token}
        isOpen={isSidebarOpen}
      />
      <div className={`content-container ${isSidebarOpen ? "expanded" : "collapsed"}`}>
        <Header user={user}  isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar} token={token} />
        <div
          className={`main-content ${isSidebarOpen ? "expanded" : "collapsed"}`}
        >
          {/* {renderContent()} */}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
